/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import queryString from 'query-string';
import { useProjectKeyByProjectResource } from '@jira/router-resources__project-context/src/useProjectKeyByProjectResource.tsx';
import { type RouteContext, Redirect } from '@atlassian/react-resource-router';

export const BoardSettingsRedirectToCSM = ({ match }: RouteContext): React.JSX.Element => (
	<Redirect
		to={`/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(
			match.params.boardId,
		)}/columns`}
		push={false}
	/>
);

export const RoadmapSettingsRedirectToTimelineSettings = ({
	match,
}: RouteContext): React.JSX.Element => (
	<Redirect
		to={`/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(
			match.params.boardId,
		)}/timeline`}
		push={false}
	/>
);

export const SpaReleaseNoteRedirectToVersionDetails = ({
	query,
}: RouteContext): React.JSX.Element | null => {
	const { version: versionId } = query;
	const { loading, error, projectKey } = useProjectKeyByProjectResource();

	if (loading === false && error) {
		return null;
	}

	if (loading) {
		return null;
	}

	if (!versionId) {
		return (
			<Redirect
				to={{
					pathname: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`,
					hash: '',
					search: '',
				}}
			/>
		);
	}

	return (
		<Redirect
			to={{
				pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
				hash: '',
				search: queryString.stringify({ isReleaseNoteModalOpen: true }),
			}}
		/>
	);
};

export const LegacyFrontendReleaseNoteRedirect = ({ query }: RouteContext): React.JSX.Element => (
	<Redirect
		to={{
			pathname: '/secure/ReleaseNote.jspa',
			hash: '',
			search: queryString.stringify({ ...query, isRedirectedFromLegacy: true }),
		}}
	/>
);

const ufoNamesMap: Record<string, string> = {
	'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
	'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp',
};

export const getUFOName = (name: string): string => ufoNamesMap[name] || name;

export const BoardCardSettingsRedirectToBoardView = ({
	match,
}: RouteContext): React.JSX.Element => (
	<Redirect
		to={`/jira/software/projects/${String(match.params.projectKey)}/boards/${String(
			match.params.boardId,
		)}?openViewSettings=true`}
		push={false}
	/>
);
